"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OmnichannelErrorCodes;
(function (OmnichannelErrorCodes) {
    OmnichannelErrorCodes[OmnichannelErrorCodes["WidgetUseOutsideOperatingHour"] = 705] = "WidgetUseOutsideOperatingHour";
})(OmnichannelErrorCodes || (OmnichannelErrorCodes = {}));
exports.default = OmnichannelErrorCodes;
//# sourceMappingURL=OmnichannelErrorCodes.js.map